import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { TEXT_DEFAULTS, type FontWeight } from './text-defaults';

export interface LimitTextOpts {
  pieceId: string;
  text: string;
  fontSize?: number;
  fontWeight?: FontWeight;
  textAlign?: 'left' | 'center' | 'right';
  position: { left: number; top: number; width: number; height: number };
  fill?: string;
}

export function buildLimitText(opts: LimitTextOpts): CanvasJSONLikeObject {
  const { pieceId, text, position, textAlign = 'center', fill = '#000', fontWeight = 400 } = opts;
  const fontSize = opts.fontSize ?? 28;
  return {
    ...TEXT_DEFAULTS,
    type: 'Textbox',
    pieceId,
    text,
    fontSize,
    fontWeight,
    lineHeight: 1.16,
    textAlign,
    originY: 'top',
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    fill,
    objectCaching: false,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    autoFit: {
      minFontSize: fontSize,
      maxFontSize: fontSize,
      maxHeight: 600,
      snapTo: 2
    }
  };
}
